import { render, staticRenderFns } from "./MemosDataTable.vue?vue&type=template&id=199c23a7"
import script from "./MemosDataTable.vue?vue&type=script&lang=js"
export * from "./MemosDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports